(function () {
  let loading = false;
  let observer;
  let loadedPages = new Set();

  function getCurrentPage() {
    const active = document.querySelector('.pagination-wrapper [aria-current="page"]');
    if (active) return parseInt(active.textContent.trim(), 10) || 1;

    const url = new URL(window.location.href);
    return parseInt(url.searchParams.get('page'), 10) || 1;
  }

  function getNextLink() {
    const currentPage = getCurrentPage();

    const links = [...document.querySelectorAll('.pagination-wrapper a[href*="page="]')];

    const nextLinks = links
      .map(link => {
        const url = new URL(link.href);
        const page = parseInt(url.searchParams.get('page'), 10);
        return { link, page };
      })
      .filter(item => item.page > currentPage)
      .sort((a, b) => a.page - b.page);

    return nextLinks.length ? nextLinks[0].link : null;
  }

  async function loadMoreProducts() {
    if (loading) return;

    const grid = document.querySelector('#product-grid');
    const nextLink = getNextLink();

    if (!grid || !nextLink) {
      cleanupInfiniteScroll();
      return;
    }

    const nextUrl = nextLink.href;

    if (loadedPages.has(nextUrl)) {
      cleanupInfiniteScroll();
      return;
    }

    loadedPages.add(nextUrl);
    loading = true;

    try {
      const res = await fetch(nextUrl);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newItems = html.querySelectorAll('#product-grid .grid__item');
      const newPagination = html.querySelector('.pagination-wrapper');
      const oldPagination = document.querySelector('.pagination-wrapper');

      if (!newItems.length) {
        cleanupInfiniteScroll();
        return;
      }

      newItems.forEach(item => grid.appendChild(item));

      if (oldPagination && newPagination) {
        oldPagination.innerHTML = newPagination.innerHTML;
      } else if (oldPagination) {
        oldPagination.remove();
      }

      initInfiniteScroll();
    } catch (err) {
      console.error('Infinite scroll error:', err);
    }

    loading = false;
  }

  function cleanupInfiniteScroll() {
    if (observer) observer.disconnect();

    const trigger = document.querySelector('#infinite-scroll-trigger');
    if (trigger) trigger.remove();

    const pagination = document.querySelector('.pagination-wrapper');
    if (pagination) pagination.remove();
  }

  function initInfiniteScroll() {
    const pagination = document.querySelector('.pagination-wrapper');
    const nextLink = getNextLink();

    if (!pagination || !nextLink) {
      cleanupInfiniteScroll();
      return;
    }

    let trigger = document.querySelector('#infinite-scroll-trigger');
    if (trigger) trigger.remove();

    trigger = document.createElement('div');
    trigger.id = 'infinite-scroll-trigger';
    trigger.innerHTML = 'Loading more...';
    trigger.style.textAlign = 'center';
    trigger.style.padding = '40px';
    trigger.style.fontSize = '12px';

    pagination.after(trigger);

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) loadMoreProducts();
    }, { rootMargin: '800px' });

    observer.observe(trigger);
  }

  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
})();